module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-3-665fd2302d20f0c50c2369ef4a11ecc6.svg";